import {Component, OnInit, Input} from '@angular/core';
import { ReceptionMarchandiseModel } from '../reception-marchandise.model';
import { Model_WorkflowComponent } from 'src/app/app.models';

@Component({
    selector: 'abw-reception-marchandise-result',
    templateUrl: './reception-marchandise-result.component.html',
    styleUrls: ['./reception-marchandise-result.component.scss']
})
export class ReceptionMarchandiseResultComponent implements OnInit {
	@Input() model: ReceptionMarchandiseModel;
    @Input() value: any;
    component: Model_WorkflowComponent;

    constructor() {
    }

    ngOnInit() {
        this.component = this.model.additional as Model_WorkflowComponent;
    }
}